/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#empTable[_ngcontent-%COMP%]{margin:1%;width:98%}.field[_ngcontent-%COMP%]{margin:1%!important}.ui.form[_ngcontent-%COMP%]   .inline.fields[_ngcontent-%COMP%]{margin:0}.centeredField[_ngcontent-%COMP%]{margin:1%;display:flex;justify-content:center;align-items:center}.button[_ngcontent-%COMP%]{margin:1%}.reqIcon[_ngcontent-%COMP%]{color:red}.ui.message[_ngcontent-%COMP%]{margin:1%;width:98%}.ui.breadcrumb[_ngcontent-%COMP%]{margin-top:1.45%;margin-left:.75%}\n/*# sourceMappingURL=leave-excuse-management.component.css.map*/"];
export { styles as styles };
